import { CloseLocations, LocationApiLocation } from 'lib/locations';
import { RootState } from 'store/configureStore';

export const selectCurrentLocation = (
  state: RootState,
): LocationApiLocation | undefined => state.app.currentLocation;

export const selectCloseLocations = (state: RootState): CloseLocations =>
  state.app.closeLocations;
